import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { productGroupConstants } from "../constants";
import {
    assignProductsToSubGroupApi,
    changeProductGroupStatusApi,
    createProductGroupApi,
    deleteProductGroupApi,
    getProductGroupDropdownApi,
    getProductGroupsApi,
    updateProductGroupApi
} from "../services/productGroupService";

export function* getProductGroupsSaga(payload) {
    try {
        const response = yield call(getProductGroupsApi, payload);
        yield put({ type: productGroupConstants.GET_PRODUCT_GROUPS_SUCCESS, response });
    } catch (error) {
        yield put({ type: productGroupConstants.GET_PRODUCT_GROUPS_FAILURE, error });
    }
}

export function* createProductGroupSaga(payload) {
    try {
        const response = yield call(createProductGroupApi, payload);
        yield put({ type: productGroupConstants.CREATE_PRODUCT_GROUP_SUCCESS, response });
    } catch (error) {
        yield put({ type: productGroupConstants.CREATE_PRODUCT_GROUP_FAILURE, error });
    }
}

export function* updateProductGroupSaga(payload) {
    try {
        const response = yield call(updateProductGroupApi, payload);
        yield put({ type: productGroupConstants.UPDATE_PRODUCT_GROUP_SUCCESS, response });
    } catch (error) {
        yield put({ type: productGroupConstants.UPDATE_PRODUCT_GROUP_FAILURE, error });
    }
}

export function* changeProductGroupStatusSaga(payload) {
    try {
        const response = yield call(changeProductGroupStatusApi, payload);
        yield put({ type: productGroupConstants.CHANGE_PRODUCT_GROUP_STATUS_SUCCESS, response });
    } catch (error) {
        yield put({ type: productGroupConstants.CHANGE_PRODUCT_GROUP_STATUS_FAILURE, error });
    }
}

export function* deleteProductGroupSaga(payload) {
    try {
        const response = yield call(deleteProductGroupApi, payload);
        yield put({ type: productGroupConstants.DELETE_PRODUCT_GROUP_SUCCESS, response });
    } catch (error) {
        yield put({ type: productGroupConstants.DELETE_PRODUCT_GROUP_FAILURE, error });
    }
}

export function* getProductGroupDropdownSaga(payload) {
    try {
        const response = yield call(getProductGroupDropdownApi, payload);
        yield put({ type: productGroupConstants.GET_PRODUCT_GROUP_DROPDOWN_SUCCESS, response });
    } catch (error) {
        yield put({ type: productGroupConstants.GET_PRODUCT_GROUP_DROPDOWN_FAILURE, error });
    }
}

export function* assignProductsToSubGroupSaga(payload) {
    try {
        const response = yield call(assignProductsToSubGroupApi, payload);
        yield put({ type: productGroupConstants.ASSIGN_PRODUCTS_TO_SUBGROUP_SUCCESS, response });
    } catch (error) {
        yield put({ type: productGroupConstants.ASSIGN_PRODUCTS_TO_SUBGROUP_FAILURE, error });
    }
}

export default function* productGroupSaga() {
    yield takeLatest(productGroupConstants.GET_PRODUCT_GROUPS, getProductGroupsSaga);
    yield takeLatest(productGroupConstants.GET_PRODUCT_GROUP_DROPDOWN, getProductGroupDropdownSaga);
    yield takeEvery(productGroupConstants.CREATE_PRODUCT_GROUP, createProductGroupSaga);
    yield takeEvery(productGroupConstants.UPDATE_PRODUCT_GROUP, updateProductGroupSaga);
    yield takeEvery(productGroupConstants.CHANGE_PRODUCT_GROUP_STATUS, changeProductGroupStatusSaga);
    yield takeEvery(productGroupConstants.DELETE_PRODUCT_GROUP, deleteProductGroupSaga);
    yield takeEvery(productGroupConstants.ASSIGN_PRODUCTS_TO_SUBGROUP, assignProductsToSubGroupSaga);
}
